/**
 * CoLab Stacking Slider Module
 * Простий stacking через position: sticky
 * Кожен слайд sticky — вони накладаються при скролі
 */

export const Stacking = {
    // DOM Elements
    container: null,
    slides: null,
    tabs: null,
    prevBtn: null,
    nextBtn: null,
    progressBar: null,

    // State
    activeIndex: 0,
    slideCount: 0,
    isAnimating: false,

    // Configuration
    config: {
        containerSelector: '.stacking',
        slideSelector: '.stacking__slide',
        tabSelector: '.stacking__tab',
        prevSelector: '.stacking__nav-btn--prev',
        nextSelector: '.stacking__nav-btn--next',
        progressSelector: '.stacking__progress-bar',

        stickyTop: 184,              // top для sticky (header + nav)
        transitionDuration: 600
    },

    /**
     * Initialize
     */
    init: function(options) {
        if (options) {
            this.config = Object.assign({}, this.config, options);
        }

        this.container = document.querySelector(this.config.containerSelector);
        if (!this.container) return;

        this.slides = this.container.querySelectorAll(this.config.slideSelector);
        this.tabs = this.container.querySelectorAll(this.config.tabSelector);
        this.prevBtn = this.container.querySelector(this.config.prevSelector);
        this.nextBtn = this.container.querySelector(this.config.nextSelector);
        this.progressBar = this.container.querySelector(this.config.progressSelector);

        if (!this.slides.length) return;

        this.slideCount = this.slides.length;

        this.setupSlides();
        this.bindEvents();
        this.updateNavButtons();

        console.log('[CoLab.Stacking] Initialized with', this.slideCount, 'slides');
    },

    /**
     * Setup slides - задаємо z-index
     */
    setupSlides: function() {
        var self = this;

        this.slides.forEach(function(slide, index) {
            // z-index: кожен наступний вище попереднього
            slide.style.zIndex = index + 1;
            slide.setAttribute('data-index', index);

            // Перший слайд активний
            if (index === 0) {
                slide.classList.add('is-active');
            }
        });
    },

    /**
     * Bind events
     */
    bindEvents: function() {
        var self = this;

        // Scroll - визначаємо активний слайд
        var ticking = false;
        window.addEventListener('scroll', function() {
            if (!ticking) {
                requestAnimationFrame(function() {
                    self.onScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });

        // Navigation buttons
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', function(e) {
                e.preventDefault();
                self.prev();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', function(e) {
                e.preventDefault();
                self.next();
            });
        }

        // Tabs
        this.tabs.forEach(function(tab, index) {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                self.goToSlide(index);
            });
        });

        // Keyboard
        document.addEventListener('keydown', function(e) {
            if (!self.isInViewport()) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                self.next();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                self.prev();
            }
        });
    },

    /**
     * On scroll - визначаємо який слайд зараз активний
     */
    onScroll: function() {
        var self = this;
        var scrollY = window.pageYOffset;
        var windowHeight = window.innerHeight;
        var newActiveIndex = 0;

        // Знаходимо слайд, який зараз найбільше видимий
        this.slides.forEach(function(slide, index) {
            var rect = slide.getBoundingClientRect();

            // Слайд вважається активним, коли його верх досяг sticky позиції
            if (rect.top <= self.config.stickyTop + 50) {
                newActiveIndex = index;
            }
        });

        if (newActiveIndex !== this.activeIndex) {
            this.setActiveSlide(newActiveIndex);
        }

        // Update progress
        this.updateProgress();
    },

    /**
     * Set active slide
     */
    setActiveSlide: function(index) {
        var self = this;

        if (index < 0 || index >= this.slideCount) return;

        var oldIndex = this.activeIndex;
        this.activeIndex = index;

        // Update slide classes
        this.slides.forEach(function(slide, i) {
            slide.classList.remove('is-active', 'is-prev');

            if (i === index) {
                slide.classList.add('is-active');
            } else if (i < index) {
                slide.classList.add('is-prev');
            }
        });

        // Update tabs
        this.tabs.forEach(function(tab, i) {
            tab.classList.toggle('is-active', i === index);
        });

        // Update nav buttons
        this.updateNavButtons();

        // Dispatch event
        this.container.dispatchEvent(new CustomEvent('slideChange', {
            detail: {
                currentIndex: index,
                previousIndex: oldIndex,
                slide: this.slides[index]
            }
        }));
    },

    /**
     * Scroll to slide
     */
    scrollToSlide: function(index) {
        var self = this;

        if (this.isAnimating) return;
        if (index < 0 || index >= this.slideCount) return;

        this.isAnimating = true;

        var slide = this.slides[index];
        var slideTop = slide.offsetTop;
        var containerTop = this.container.offsetTop;

        // Скролимо до позиції слайда
        var targetScroll = containerTop + slideTop - this.config.stickyTop;

        window.scrollTo({
            top: targetScroll,
            behavior: 'smooth'
        });

        setTimeout(function() {
            self.isAnimating = false;
        }, this.config.transitionDuration);
    },

    /**
     * Go to slide
     */
    goToSlide: function(index) {
        this.scrollToSlide(index);
    },

    /**
     * Next slide
     */
    next: function() {
        if (this.activeIndex < this.slideCount - 1) {
            this.goToSlide(this.activeIndex + 1);
        }
    },

    /**
     * Previous slide
     */
    prev: function() {
        if (this.activeIndex > 0) {
            this.goToSlide(this.activeIndex - 1);
        }
    },

    /**
     * Update nav buttons
     */
    updateNavButtons: function() {
        if (this.prevBtn) {
            this.prevBtn.disabled = this.activeIndex === 0;
            this.prevBtn.classList.toggle('is-disabled', this.activeIndex === 0);
        }

        if (this.nextBtn) {
            this.nextBtn.disabled = this.activeIndex === this.slideCount - 1;
            this.nextBtn.classList.toggle('is-disabled', this.activeIndex === this.slideCount - 1);
        }
    },

    /**
     * Update progress bar
     */
    updateProgress: function() {
        if (!this.progressBar) return;

        var progress = this.activeIndex / (this.slideCount - 1);
        this.progressBar.style.transform = 'scaleX(' + progress + ')';
    },

    /**
     * Check if in viewport
     */
    isInViewport: function() {
        var rect = this.container.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    },

    /**
     * Destroy
     */
    destroy: function() {
        this.slides.forEach(function(slide) {
            slide.style.zIndex = '';
            slide.classList.remove('is-active', 'is-prev');
        });
        console.log('[CoLab.Stacking] Destroyed');
    }
};
